import React from "react";
import naming from "../../assets/images/logo naming white.svg"

function DesktopNavbarBrand({ navigate }) {
  return (
    <div className="flex items-center gap-1">
          <button
              className="hover:bg-[#575757] px-3 py-1 rounded-md transition duration-300"
              onClick={() => navigate("/")}
          >
              <img
                  src={naming}
                  alt="Ranobe-LIFE"
                  className="h-[clamp(18px,4vw,32px)] w-auto"
              />
          </button>
    </div>
  );
}

export default DesktopNavbarBrand;
